<template>
  <section class="login">
    <div v-if="session && !counter" class="login__form login__countdown">
      <rum-countdown :left-time="3000">
        <span class="countdown__steps" slot="process" slot-scope="{ timeObj }">{{ timeObj.ceil.s }}</span>
      </rum-countdown>
      <p style="font-size: var(--lg);">You will be redirected...</p>
    </div>
    <form v-else class="login__form" @submit.prevent="login">
      <img class="login-form__logo" src="@/assets/images/logo.svg" alt="Rumie" />
      <label class="login-form__label">Login</label>
      <rum-input type="text" placeholder="Email" class="login-form__username" v-model="username" />
      <rum-input
        type="password"
        placeholder="Password"
        class="login-form__password"
        v-model="password"
      />

      <aside v-if="error" class="login-form__error">Invalid credentials.</aside>
      <rum-loader class="login-form__loader" center v-if="working" />
      <div v-else class="login-form__actions">
        <rum-button class="login-form__submit" type="submit" :disabled="disabled">Login</rum-button>
        <router-link class="primary-link" :to="{name: 'ForgotPassword'}">Forgot my password</router-link>
      </div>
    </form>
    <aside class="login__welcome">
      <title
        class="login-welcome__message"
      >Welcome to the<span class="login-welcome__message--primary"> Rumie-Connect</span></title>
    </aside>
  </section>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      username: "",
      password: "",
      working: false,
      error: false
    };
  },
  computed: {
    session() {
      return this.$route.query.session;
    },
    nextUrl() {
      return this.$route.query.next;
    },
    counter() {
      return this.$route.query.counter;
    },
    expressSession() {
      return this.$route.query.express_token;
    },
    token() {
      return this.$store.getters.token;
    },
    cubejsToken() {
      return this.$store.getters.cubejsToken;
    },
    disabled() {
      return !this.username || !this.password;
    }
  },
  methods: {
    async login() {
      this.error = false;
      this.working = true;
      const { username, password } = this;
      try {
        await this.$store.dispatch("login", { username, password });
        await this.$store.dispatch("fetchUser");
        await this.$store.dispatch("fetchCubejsToken");
        this.$router.push({ name: "ProjectList" });
        this.working = false;
      } catch (e) {
        this.error = true;
        this.working = false;
      }
    },
    async sessionLogin() {
      this.working = true;
      const token = this.session;
      const expressToken = this.expressSession;

      await this.$store.dispatch("sessionLogin", { token, expressToken });
      await this.$store.dispatch("fetchUser");
      await this.$store.dispatch("fetchCubejsToken");

      const redirectPath = this.$route.query.next || "/";
      const redirectTime = this.$route.query.next && this.counter ? 0 : 3000;
      setTimeout(() => this.$router.push(redirectPath), redirectTime);
      this.working = false;
    }
  },
  beforeMount() {
    if (this.session) {
      this.sessionLogin();
    } else if (this.token) {
      this.$router.push({ name: "ProjectList" });
    }
  }
};
</script>

<style scoped>
.login__countdown {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--xl3);
}

.countdown__steps {
  border: 2px solid;
  border-radius: var(--border-radius-full);
  height: 50px;
  width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--grey-dark);
}

.login {
  background: var(--white);
  height: 100vh;
  width: 100vw;
  display: flex;
  box-sizing: border-box;
}

.login__form {
  width: 25%;
  background: var(--white);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: left;
  padding: var(--spacing-8);
}

.login-form__logo {
  display: none;
}

.login-form__label {
  font-weight: bold;
  margin-bottom: var(--spacing-4);
}

.login-form__username {
  margin-bottom: var(--spacing-2);
}

.login-form__password {
  margin-bottom: var(--spacing-2);
}

.login-form__error {
  color: var(--red-dark);
  margin-top: var(--spacing-2);
  margin-bottom: var(--spacing-2);
  font-weight: var(--bold);
  font-size: var(--xs);
}

.login-form__loader {
  margin-top: var(--spacing-8);
}

.login-form__actions {
  margin-top: var(--spacing-2);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.login__welcome {
  width: 75%;
  /* height: 100%; */
  background: #474450;
  background-image: url("~@/assets/images/login-welcome.png");
  background-size: cover;
}

.login-welcome__message {
  font-size: var(--xl5);
  font-weight: var(--light);
  color: var(--white);
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  flex-direction: column;
}

.login-welcome__message--primary {
  color: var(--orange);
}

@media screen and (max-width: 900px) {
  .login__form {
    width: 100%;
  }

  .login-form__logo {
    display: block;
    margin-bottom: var(--spacing-16);
    height: 34px;
  }

  .login__welcome {
    display: none;
  }
}
</style>
